import React, { Component } from 'react';
import { Button, Card, CardBody, Row, Col, InputGroup, InputGroupAddon, Input, Form } from 'reactstrap';
import { CommonHelper } from '../Base/Common/CommonUIComponents';
import TimelineElement from '../Base/Common/TimelineElement';
import CustomSelect from '../Base/Common/CustomSelect';
import { ErrorAlert } from "../Base/ErrorAlert";
import { DateRangePicker } from 'react-dates';
import { FormattedMessage } from 'react-intl';
import Timeline from '../Base/Common/Timeline';
import '../Base/Common/TimelineElement.css';
import '../Base/Common/Timeline.css';
import { getAPI } from "../Base/API";
import BlockUi from 'react-block-ui';
import { Link } from 'react-router-dom';
import moment from 'moment';

const DisplayIcon = ({ eventType, result, action }) => {
    var badgecolor = "badge-secondary";
    if (result === 2) badgecolor = "badge-danger"
    else if (result === 3) badgecolor = "badge-warning";

    var classname = "";
    if (eventType === 'Payment') classname = "fa-solid fa-credit-card"
    else if (eventType === 'PaymentCustomer') classname = "fa-regular fa-id-card"
    else if (eventType === 'PmsReservations' || eventType === 'Pms' || eventType === 'PmsReferenceData') classname = "fa-solid fa-suitcase"
    else if (eventType === 'Invoice') classname = "fa-solid fa-receipt"
    else if (eventType === 'RateCode') classname = "fa-solid fa-dollar-sign"
    else if (eventType === 'OnlineSale' || eventType === 'RedeemVoucher') classname = "fa-solid fa-wallet"
    else if (eventType === 'User') classname = "fa-solid fa-user"
    else if (eventType === 'EmitVoucher' || eventType === 'SetVoucherState') classname = "fa-solid fa-gift"
    else if (eventType === 'ExternalApi') classname = "fa-solid fa-plug"
    else if (eventType === 'Ai') classname = "fa-solid fa-wand-magic-sparkles"
    else if (eventType === 'Voucher') {
        if (action === 'Redeem') classname = "fa-solid fa-wallet"
        else if (action === 'Recharge') classname = "fa-solid fa-hand-holding-dollar"
        else if (action === 'AssociateProfileOrReservation') classname = "fa-solid fa-link"
        else classname = "fa-solid fa-gift"
    }
        

    return <span className={'d-flex align-items-center justify-content-center badge ' + badgecolor} style={{ width: '28px', height: '28px', fontSize: '18px' }}><i className={classname}></i></span>;
}

const logTypesWithVoucherFilter = ['Voucher', 'Payment', 'Invoice', 'ExternalApi'];

const externalApiActions = ['GetVoucherTypes', 'GetVoucher', 'GetVoucherDetail', 'SearchVoucher', 'VouchersUpdatedAfterDate', 'VoucherUsageAfterDate', 'GetCancellationReasons', 'GetVoucherTags'];

const actionOptions = [
    {
        value: 'OnlineSale',
        label: <FormattedMessage id="LogsDashboard.OnlineSale" />,
        types: ['Voucher', 'Invoice']
    },
    {
        value: 'Voucher',
        label: <FormattedMessage id="LogsDashboard.Voucher" />,
        types: ['Invoice']
    },
    {
        value: 'SetVoucherState',
        label: <FormattedMessage id="LogsDashboard.SetVoucherState" />,
        types: ['Voucher']
    },
    {
        value: 'ExpiredVoucher',
        label: <FormattedMessage id="LogsDashboard.ExpiredVoucher" />,
        types: ['Invoice']
    },
    {
        value: 'Recharge',
        label: <FormattedMessage id="LogsDashboard.Recharge" />,
        types: ['Invoice']
    },
    {
        value: 'Redeem',
        label: <FormattedMessage id="LogsDashboard.Redeem" />,
        types: ['Voucher', 'Invoice']
    },
    {
        value: 'AssociateProfileOrReservation',
        label: <FormattedMessage id="LogsDashboard.AssociateProfileOrReservation" />,
        types: ['Voucher']
    },
    {
        value: 'Register',
        label: <FormattedMessage id="LogsDashboard.Register" />,
        types: ['Voucher']
    },
    {
        value: 'Checkout',
        label: <FormattedMessage id="LogsDashboard.Checkout" />,
        types: ['Payment']
    },
    /*{ Era usado na unicre
        value: 'Webhook',
        label: <FormattedMessage id="LogsDashboard.Webhook" />,
        types: ['Payment']
    },*/
    {
        value: 'CheckStatus',
        label: <FormattedMessage id="LogsDashboard.CheckStatus" />,
        types: ['Payment']
    },
    {
        value: 'Refund',
        label: <FormattedMessage id="LogsDashboard.Refund" />,
        types: ['Payment']
    },
    {
        value: 'CustomerCreation',
        label: <FormattedMessage id="LogsDashboard.CustomerCreation" />,
        types: ['Payment']
    },
    {
        value: 'TestConnection',
        label: <FormattedMessage id="LogsDashboard.TestConnection" />,
        types: ['Pms']
    },
    /*{
        value: 'GetRateCodes',
        label: <FormattedMessage id="LogsDashboard.GetRateCodes" />,
        types: ['Pms']
    },
    {
        value: 'GetOnlineChannels',
        label: <FormattedMessage id="LogsDashboard.GetOnlineChannels" />,
        types: ['Pms']
    },*/
    {
        value: 'GetPaymentMethods',
        label: <FormattedMessage id="LogsDashboard.GetPaymentMethods" />,
        types: ['Pms']
    },
    {
        value: 'GetUsers',
        label: <FormattedMessage id="LogsDashboard.GetUsers" />,
        types: ['Pms']
    },
    ...externalApiActions.map(action => ({
        value: action,
        label: <FormattedMessage id={"LogsDashboard." + action} />,
        types: ['ExternalApi']
    })),
    {
        value: 'TemplateAssistant',
        label: <FormattedMessage id="LogsDashboard.TemplateAssistant" />,
        types: ['Ai']
    }
]

const typeOptions = [
    {
        value: 'Voucher',
        label: <FormattedMessage id="LogsDashboard.Voucher" />
    },
    {
        value: 'Payment',
        label: <FormattedMessage id="LogsDashboard.Payment" />
    },
    {
        value: 'Invoice',
        label: <FormattedMessage id="LogsDashboard.Invoice" />
    },
    {
        value: 'Pms',
        label: "PMS"
    },
    {
        value: 'PmsReferenceData',
        label: <FormattedMessage id="LogsDashboard.PmsReferenceData" />
    },
    {
        value: 'ExternalApi',
        label: <FormattedMessage id="LogsDashboard.ExternalApi" />
    },
    {
        value: 'Ai',
        label: <FormattedMessage id="LogsDashboard.Ai" />
    },
]


const statusOptions = [
    {
        value: '1',
        label: <FormattedMessage id="LogsDashboard.Ok" />
    },
    {
        value: '2',
        label: <FormattedMessage id="LogsDashboard.Error" />
    },
    {
        value: '3',
        label: <FormattedMessage id="LogsDashboard.Warning" />
    }
]

class LogsDashboard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: null,
            block: true,
            detailBlock: false,
            actionSelected: null,
            typeSelected: null,
            statusSelected: false,
            hotelSelected: null,
            hotels: [],
            resultsPerPage: 10,
            currentPage: 0,
            selectedEvent: {},
            totalEvents: 0,
            events: [],
            startDate: moment().subtract(7, 'days'),
            endDate: moment(),
            lastSelected: 0
        };
    }

    toggleModal = () => {
        this.setState(prevState => ({
            modal: !prevState.modal
        }));
    }

    viewEventDetails = (id) => {
        this.setState({ detailBlock: true });

        const event = this.state.events.find(event => event.id === id);

        this.setState({ selectedEvent: event, lastSelected: id, detailBlock: false });
    }

    componentDidMount() {
        this.getEvents();
        this.getHotels();
    }

    getHotels = () => {
        getAPI(result => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: "danger" });
                this.setState({ error: errorMessage });
                return;
            }
            if (data && data.response && data.response.length > 0 && data.response[0].hotels) {
                const hotels = data.response[0].hotels.map(el => ({ value: el.hotelId, label: el.name2 }));
                this.setState({ hotels });
            }
        }, '/api/Voucher/Hotel/v1/hotel');
    }

    getHotelName = (hotelId) => {
        const hotel = this.state.hotels.find(el => el.value === hotelId);
        return hotel ? hotel.label : null;
    }

    changePage = (evt, val) => {
        this.setState({
            currentPage: this.state.currentPage + val, block: true
        }, () => this.getEvents());
    }

    getEvents = () => {
        this.setState({ block: true });
        let params = '';
        params += this.state.actionSelected ? `&action=${this.state.actionSelected}` : '';
        params += this.state.typeSelected ? `&eventType=${this.state.typeSelected}` : '';
        params += this.state.statusSelected ? `&result=${this.state.statusSelected}` : '';
        params += this.state.searchId ? `&searchId=${this.state.searchId}` : '';
        params += this.state.hotelSelected ? `&hotelId=${this.state.hotelSelected}` : '';

        getAPI((result) => {
            const { data, error } = result;
            if (error) {
                var errorMessage = [];
                errorMessage.push({ message: error.message, stack: error.stack, messageType: "danger" });
                this.setState({ error: errorMessage, block: false });
                return;
            }
            if (data) {
                if (data.errors && data.errors.length > 0) {
                    data.errors.forEach(error => errorMessage.push({ message: error.message, messageType: 'danger' }));
                    this.setState(({ block: false, error: errorMessage }));
                    return;
                }
                this.setState({ events: data.response, totalEvents: data.count, block: false });
            }
        }, `/api/Voucher/v1/Events/channelEvents?&startDate=${moment(this.state.startDate).format("YYYY-MM-DD")}&endDate=${moment(this.state.endDate).format("YYYY-MM-DD")}&pageIndex=${this.state.currentPage}&pageSize=10` + params);
    }

    handleSelect = (name, combo) => {
        this.setState({
            [name]: combo ? combo.value : null
        });
    }

    handleChangeType = (combo) => {
        const value = combo ? combo.value : null;
        const searchId = logTypesWithVoucherFilter.includes(value) ? this.state.searchId : null;

        this.setState({
            typeSelected: value,
            searchId
        });
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    doSearch = () => {
        this.setState({
            currentPage: 0
        }, () => this.getEvents())
    }

    getRedirectUrl = (id, eventType, action) => {
        if (!id.includes('-') && (action === 'OnlineSale' || eventType === 'Payment')) {
            return `/OnlineSalesDetail/${id}`;
        }
        else return `/VoucherOperationDetails/${id}`;
    }

    render() {
        const { typeSelected } = this.state;

        return (
            <div>
                <BlockUi tag="div" blocking={this.state.block}>
                    <ErrorAlert error={this.state.error} />
                    <Row>
                        <Col className="col-12 ">
                            <Card className="small bg-white border-top-0 border-right-0 border-left-0">
                                <CardBody>
                                    <Form onSubmit={(e) => { e.preventDefault(); this.doSearch(); }} >
                                        <Row>
                                            <Col className="col-2">
                                                <CustomSelect
                                                    icon={'fa fa-exclamation-triangle fa-fw'}
                                                    isClearable isSearchable
                                                    placeholder={<FormattedMessage id="LogsDashboard.Status" />}
                                                    options={statusOptions}
                                                    onChange={this.handleSelect.bind(this, 'statusSelected')}
                                                />
                                            </Col>
                                            <Col className="col-2">
                                                <CustomSelect
                                                    icon={'fa fa-filter fa-fw'}
                                                    isClearable isSearchable
                                                    placeholder={<FormattedMessage id="LogsDashboard.EventType" />}
                                                    options={typeOptions}
                                                    onChange={this.handleChangeType}
                                                />
                                                
                                                {logTypesWithVoucherFilter.includes(typeSelected) ?
                                                    <InputGroup size="sm text-right " className="mt-1">
                                                        <InputGroupAddon addonType="prepend"><span className="input-group-text"><span className="fa-solid fa-key fa-fw pr-1"></span></span></InputGroupAddon>
                                                        <FormattedMessage id="OnlineSalesDetail.SearchById">
                                                            {
                                                                placeholder => <Input
                                                                    className="border-left-0"
                                                                    type="text"
                                                                    name="searchId"
                                                                    maxLength="50"
                                                                    id="searchId"
                                                                    placeholder={placeholder}
                                                                    value={this.state.searchId || ''}
                                                                    onChange={(e) => this.handleChange(e)}
                                                                />
                                                            }
                                                        </FormattedMessage>
                                                    </InputGroup> 
                                                : ''}
                                            </Col>
                                            <Col className="col-2">
                                                <CustomSelect
                                                    icon={'fa fa-filter fa-fw'}
                                                    isClearable isSearchable
                                                    placeholder={<FormattedMessage id="LogsDashboard.Action" />}
                                                    options={typeSelected ? actionOptions.filter(option => option.types.includes(typeSelected)) : actionOptions}
                                                    onChange={this.handleSelect.bind(this, 'actionSelected')}
                                                />
                                            </Col>
                                            <Col className="col-2">
                                                <CustomSelect
                                                    icon={'fa-solid fa-hotel fa-fw'}
                                                    isClearable isSearchable
                                                    placeholder={<FormattedMessage id="LogsDashboard.Hotel" />}
                                                    options={this.state.hotels}
                                                    onChange={this.handleSelect.bind(this, 'hotelSelected')}
                                                />
                                            </Col>
                                            <Col className="col-2 px-1">
                                                <InputGroup size="sm logsDashboard">
                                                    <DateRangePicker
                                                        startDate={this.state.startDate ? moment(this.state.startDate) : null}
                                                        startDateId="startDateId"
                                                        isOutsideRange={day => day > moment().add(1, 'days')}
                                                        endDate={this.state.endDate ? moment(this.state.endDate) : null}
                                                        endDateId="endDateId"
                                                        onDatesChange={({ startDate, endDate }) => this.setState({ startDate, endDate })}
                                                        focusedInput={this.state.focusedInput}
                                                        onFocusChange={focusedInput => this.setState({ focusedInput })}
                                                        small={true}
                                                        numberOfMonths={2}
                                                        showDefaultInputIcon={true}
                                                        required
                                                    />
                                                </InputGroup>
                                            </Col>
                                            <Col className="text-right pr-0">
                                                <Button className="btn btn-host shadow btn-sm" type="submit">
                                                    <span className="fa-solid fa-magnifying-glass"></span>
                                                </Button>

                                                <CommonHelper help={<FormattedMessage id="LogsDashboard.Help" />} id="logsDashboard" />
                                            </Col>
                                        </Row>
                                    </Form>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <div className="small">
                        <Timeline layout='1-column' selectedEvent={this.state.selectedEvent} block={this.state.detailBlock} >
                            {this.state.events && this.state.events.map((item, key) => {
                                const hotelName = this.getHotelName(item.hotelId);

                                return <div key={key} >
                                    <TimelineElement
                                        icon={<DisplayIcon eventType={item.eventType} result={item.result} action={item.action} />}
                                        date={moment(item.createdAt).calendar()}
                                        eventId={item.id}
                                        viewEventDetails={this.viewEventDetails}
                                        lastSelected={this.state.lastSelected}
                                        user={item.userName}
                                    >

                                        <Row className="timeline-element-subtitle">
                                            <FormattedMessage id={'LogsDashboard.' + item.eventType + '.' + item.action} />

                                            {hotelName ?
                                                <span className="ml-2 text-muted">
                                                    <i className="fa-solid fa-hotel fa-fw mr-1"></i>{hotelName}
                                                </span>
                                            : ''}

                                            {item.ids && item.ids.length > 0 ?
                                                <span className="ml-1">
                                                    ( {item.ids.map((el, key) =>
                                                        <Link to={this.getRedirectUrl(el, item.eventType, item.action)} key={key}>
                                                            <span className="pr-1"> {el}{key < item.ids.length - 1 ? ', ' : ''} </span>
                                                        </Link>
                                                    )} )
                                                </span>
                                            : ''}
                                        </Row>
                                    </TimelineElement>
                                </div>;
                            })}
                        </Timeline>
                        <Row>
                            <Col className="col-5 text-center">
                                <Button className="btn-host shadow btn-sm float-left" disabled={this.state.currentPage === 0 ? true : false} onClick={() => this.changePage(this, -1)}><i className="fa-solid fa-angle-left"></i></Button>
                                <span className="align-middle">
                                    <strong>
                                        <FormattedMessage id="LogsDashboard.Page" /> {this.state.currentPage + 1}  / {Math.ceil(this.state.totalEvents / this.state.resultsPerPage)}
                                    </strong>
                                </span>
                                <Button className="btn-host btn-sm shadow float-right" disabled={this.state.events && this.state.events.length < this.state.resultsPerPage ? true : false} onClick={() => this.changePage(this, 1)}><i className="fa-solid fa-angle-right"></i></Button>

                            </Col>
                        </Row>
                    </div>
                </BlockUi>
            </div>

        );

    }
}
export default LogsDashboard;